import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import editGreenIcon from "../../images/editGreenIcon.svg";
import trashIcon from "../../images/trashIcon.svg";
import { PostService } from "../../services/genericPostService";
import { resources_EN } from "../componentUtils";
import Swal from "sweetalert2";
import { Path } from "../../RoutesUtils";

const PrescriptionCard = ({
  presc_name,
  presc_quan,
  presc_stock_rem_date,
  presc_comments,
  presc_id,
  getPrescription,
}) => {
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  /* Delete Prescription */
  const deletePrescription = () => {
    const data = {
      user_id: userId,
      prescription_id: presc_id,
    };
    const url = "/fmeApi/delete_medicine_prescription.php";
    PostService(url, data, modal);
  };

  /* Generic Modal */
  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        getPrescription();
      }
    });
  };

  /* Confirmation Modal */
  const confirmationModal = () => {
    Swal.fire({
      title: "Er du sikker?",
      text: "Du vil ikke kunne fortryde dette!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ja, slet det!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePrescription();
      }
    });
  };

  /* Redirect to Edit */
  const redirectEdit = () => {
    navigate(Path.editPrescription, {
      state: {
        presc_name: presc_name,
        presc_quan: presc_quan,
        presc_stock_rem_date: presc_stock_rem_date,
        presc_comments: presc_comments,
        presc_id: presc_id,
      },
    });
  };
  return (
    <div className="bg-[#053B3F] text-white md:p-6 p-5 rounded-xl">
      <div className="mb-2">
        <h2 className="text-lg font-medium">{presc_name}</h2>
      </div>
      <div className="space-y-2 text-base">
        <div className="flex items-center space-x-1">
          <span className="font-normal">Quantity left:</span>
          <span className="text-red-500">{presc_quan}</span>
        </div>
        <div className="flex items-center space-x-1">
          <span>Stock reminder date:</span>
          <span className="text-[#67CCB2]">{presc_stock_rem_date}</span>
        </div>
        <p className="text-gray-300 font-light text-sm mt-2">
          {presc_comments}
        </p>
      </div>
      <div className="flex justify-between lg:mt-12 mt-4">
        <a
          style={{ cursor: "pointer" }}
          onClick={redirectEdit}
          className="flex text-[#67CCB2] items-center text-sm"
        >
          <img src={editGreenIcon} className="mr-1" alt="" />
          Redigere
        </a>
        <button
          className="flex items-center text-[#F02B2B] text-sm"
          onClick={confirmationModal}
        >
          <img src={trashIcon} className="mr-1" alt="" />
          Slet
        </button>
      </div>
    </div>
  );
};

export default PrescriptionCard;
